// Yes we really need a require here.
// eslint-disable-next-line
// @ts-ignore-error
const Denque = require('denque');
/**
 * A deque that uses {@link Denque} but with a `setAt` function.
 */
export class Deque extends Denque {
    /**
     * Set a value on a specific index.
     *
     * This function is weirdly enough not in Denque, so we simply add it
     * ourselves. This is simply `peekAt`, but modified to set a value instead of
     * returning it.
     *
     * @param index The index to set the value at.
     * @param value The value to set.
     * @returns The old value if it existed.
     */
    setAt(index, value) {
        const len = this.length;
        let i = index;
        if (i >= len || i < -len) {
            return undefined;
        }
        else if (i < 0) {
            i += len;
        }
        const self = this;
        // eslint-disable-next-line no-underscore-dangle
        i = (self._head + i) & self._capacityMask;
        // eslint-disable-next-line
        const old = self._list[i];
        // eslint-disable-next-line
        self._list[i] = value;
        return old;
    }
}
